import React, { useState, useEffect, useRef } from 'react';

const AuthBackground = ({ children, blurredForeground = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [imageIndices, setImageIndices] = useState([1, 2, 3]);
  const timeoutRef = useRef();
  const [backgroundOffset, setBackgroundOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!blurredForeground) return;

    const interval = setInterval(() => {
      setBackgroundOffset({
        x: Math.sin(Date.now() / 2000) * 10, // oscillate between -10 and +10
        y: Math.cos(Date.now() / 3000) * 10,
      });
    }, 100); // update every 100ms

    return () => clearInterval(interval);
  }, [blurredForeground]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3);
      timeoutRef.current = setTimeout(() => {
        setImageIndices(prevIndices => {
          const newIndices = [...prevIndices];
          const indexToUpdate = (activeIndex + 2) % 3;
          newIndices[indexToUpdate] = (newIndices[indexToUpdate] % 13) + 1;
          return newIndices;
        });
      }, 1000);
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeoutRef.current);
    };
  }, [activeIndex]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 0,
    }}>
      {[0, 1, 2].map((index) => (
        <div
          key={index}
          style={{
            backgroundImage: `url(/images/${imageIndices[index]}.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            opacity: activeIndex === index ? 1 : 0,
            transform: `
  ${activeIndex === index ? 'translateY(0)' : 'translateY(10px)'}
  translateX(${backgroundOffset.x}px)
  translateY(${backgroundOffset.y}px)
`,
            transition: 'opacity 1s ease-in-out, transform 1s ease-in-out',
            zIndex: 1,
          }}
        />
      ))}

      {/* Foreground with optional blur */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          ...(blurredForeground && {
            backdropFilter: 'blur(15px)',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          }),
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AuthBackground;
